import { PropsWithChildren } from 'react';

import { Box } from '@material-ui/core';

import { TCardProps } from './types';

import { cmpStyle } from './styles';

export const Card = ({ className, children }: PropsWithChildren<TCardProps>) => {
  const classes = cmpStyle();

  return <Box className={`${classes.root} ${className}`}>{children}</Box>;
};
